import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { AclosetShopPlatformTypeCode } from '@/MetadataType';
import { aimsApi } from '@/axios/AclosetApi';

export const 플랫폼_쿼리키 = createQueryKeys('platform', {
  플랫폼_주소_조회: ({ shopID, platformType }: { shopID: string; platformType: AclosetShopPlatformTypeCode }) => ({
    queryKey: [shopID, platformType] as const,
    queryFn: async () => {
      const res = await aimsApi.shops.platformUrlList({ shopId: shopID, platformType });
      return res.data;
    },
  }),
});
